// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"_3AaseX","footer":"_2y4IvY","textCancel":"_3gb35L","shine-lines":"_3D_5iL"};